// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","video":"Hero_video__uxlw6","banner":"Hero_banner__-xsVM","title":"Hero_title__rL9MQ","content":"Hero_content__YK9OZ"};